import WithGASetup from '../../components/WithGASetup';
import DoctorInitialSignupPage from './DoctorInitialSignupPage.js';

export default WithGASetup(DoctorInitialSignupPage);
